import React from 'react';

import { useAtom } from 'jotai';

import { uiRoutes } from '@consumer-frontend/api';
import {
  Container,
  Icon,
  Image,
  Link,
  Navbar,
  NavbarOffcanvas,
  NavbarToggle,
} from '@consumer-frontend/shared-ui';

import { showMobileNavAtom } from '../../store';
import { BlocNav } from '../CnuBlocNav';
import { CnuNav } from '../CnuNav';

import styles from './CnuHeader.module.scss';
import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/header.scss';

export type CnuHeaderPropsT = {
  isBlocCustomer: boolean;
  centeredLogo?: boolean;
  logoUri?: string;
  renderNav?: boolean;
};

export type CnuHeaderT = React.FC<CnuHeaderPropsT>;

export const CnuHeader: React.FC<CnuHeaderPropsT> = ({
  isBlocCustomer,
  logoUri = '/assets/images/CNU_Logo.svg',
  centeredLogo = false,
  renderNav = true,
}) => {
  const [showMobileNav, setShowMobileNav] = useAtom(showMobileNavAtom);
  const logoLink = isBlocCustomer ? uiRoutes.blocAccountSummary : uiRoutes.accountHome;
  const centeredClass = centeredLogo ? styles.centeredHeader : '';

  return (
    <>
      {/* Desktop header */}
      <Container
        hasBoxShadow
        className={[
          'd-none',
          'd-md-flex',
          'w-100',
          'header',
          centeredClass,
        ].join(' ')}
      >
        <Link to={logoLink}>
          <Image
            className="logo-img"
            alt="CashNetUSA Logo"
            src={logoUri}
          />
        </Link>
      </Container>

      {/* Mobile header */}
      <Navbar className="p-0" expand={false}>
        <Container
          hasBoxShadow
          className={[
            'd-flex',
            'd-md-none',
            'p-0',
            'w-100',
            'header',
            centeredClass,
          ].join(' ')}
        >
          {renderNav && (
            <>
              <NavbarToggle
                aria-controls="offcanvas"
                data-testid="offcanvas-toggle"
                className={['border-0', 'hamburger'].join(' ')}
                onClick={() => setShowMobileNav(true)}
              >
                <Icon className={['d-flex', 'toggle-icon'].join(' ')} iconName="list" />
              </NavbarToggle>
              <NavbarOffcanvas
                aria-labelledby="offcanvas"
                id="offcanvas"
                show={showMobileNav}
                onKeyDown={(e) => e.key === 'Escape' && setShowMobileNav(false)}
              >
                <Container className="mobile-nav">
                  <NavbarToggle
                    aria-controls="offcanvas"
                    data-testid="in-content-offcanvas-toggle"
                    className={['border-0', 'close-icon'].join(' ')}
                    onClick={() => setShowMobileNav(false)}
                  >
                    <Icon className={['d-flex', 'toggle-icon'].join(' ')} iconName="x-lg" />
                  </NavbarToggle>
                  {isBlocCustomer
                    ? <BlocNav responsiveFlexClass="d-flex" />
                    : <CnuNav responsiveFlexClass="d-flex" />}
                </Container>
              </NavbarOffcanvas>
            </>
          )}
          <Link to={logoLink}>
            <Image className="logo-img" alt="CashNetUSA Mobile Logo" src={logoUri} />
          </Link>
        </Container>
      </Navbar>
    </>
  );
};
